const trimAndLowerCase = (name) => name.trim().toLowerCase()

export default trimAndLowerCase
